export default Object.freeze({
  common: {
    subject: {
      Aborto: "Aborto",
      Género: "Género",
      Eutanasia: "Euthanasia",
      Salud: "Salud",
      Familia: "Familia",
      Violencia: "Violencia",
      Educación: "Educación",
      Vida: "Vida",
      Libertad: "Libertad",
      Otros: "Otros",
    },
  },
  project: {
    projectType: {
      iniciativa: "Iniciativa",
      dictamen: "Dictamen",
      sentencia: "Sentencia",
    },
    position: {
      Registro: "Registro",
      Comisiones: "Comisiones",
      Pleno: "Pleno",
      "En revisora": "En revisora",
      Ejecutivo: "Ejecutivo",
      Retirado: "Retirado",
      Desechado: "Desechado",
      "Caducidad legislativa": "Caducidad legislativa",
      Publicado: "Publicado",
      "En vigor": "En vigor",
      Dictaminado: "Dictaminado",
      "Sala/Pleno": "Sala/Pleno",
      Resuelto: "Resuelto",
    },
    type: {
      Abroga: "Abroga",
      Deroga: "Deroga",
      "Deroga y Reforma": "Deroga y Reforma",
      Exhorto: "Exhorto",
      "Nueva Ley": "Nueva Ley",
      Reforma: "Reforma",
      Reserva: "Reserva",
      Solicitud: "Solicitud",
      Otro: "Otro",
      "Acción inconstitucionalidad": "Acción inconstitucionalidad",
      "Amparo directo": "Amparo directo",
      "Amparo directo en revisión": "Amparo directo en revisión",
      "Amparo en revisión": "Amparo en revisión",
      "Controversia constitucional": "Controversia constitucional",
    },
  },
  publication: {
    media: {
      Fotografia: "Fotografia",
      Periodico: "Periodico",
      Radio: "Radio",
      "Red Social": "Red Social",
      Sitio: "Sitio",
      TV: "TV",
      Video: "Video",
      Testimonio: "Testimonio",
      "Propuesta de Gobierno": "Propuesta de Gobierno",
      Otro: "Otro",
    },
    status: {
      Original: "Original",
      Cambiado: "Cambiado",
      Excluido: "Excluido",
    },
  },
  voting: {
    votingType: {
      discusion: "Discusión",
      votacion: "Votación",
      votacion_scjn: "Votación (SCJN)",
    },
    status: {
      "En estudio": "En estudio",
      Finalizado: "Finalizado",
    },
    result: {
      Pendente: "Pendente",
      "No aprobado": "No aprobado",
      Aprobado: "Aprobado",
    },
    direction: {
      Validez: "Validez",
      Invalidez: "Invalidez",
      Sobreseimiento: "Sobreseimiento",
    },
    type: {
      Nominal: "Nominal",
      Económica: "Económica",
      "Por cédula": "Por cédula",
      Provisional: "Provisional",
    },
  },
  vote: {
    option: {
      "A favor": "A favor",
      "En contra": "En contra",
      Abstencion: "Abstención",
      Ausente: "Ausente",
      null: "Sin información",
      undefined: "Sin información",
      "": "Sin información",
    },
  },
  label: {
    list: "Listado",
    projects: "Proyectos",
    dictamen: "Dictamen",
    politicians: "Políticos",
    politician: "Político",
    votings: "Votaciones",
    votes: "Votos",
    vote: "Voto",
    publications: "Publicaciones",
    accounts: "Establecimientos",
    account: "Establecimiento",
    comissions: "Comisiónes",
    comission: "Comisión",
    plenos: "Plenos",
    period: "Periodo",
    filters: "Filtros",
    projectType: "Tipo de proyecto",
    votingType: "Tipo de votación",
    alias: "Alias",
    position: "Posición",
    subject: "Tema",
    subsubject: "Subtema",
    type: "Tipo",
    otherType: "Otro tipo",
    source: "Origen",
    party: "Partido",
    electionType: "Tipo de elección",
    electoralDistrict: "Distrito electoral",
    iniciativas: "Iniciativas",
    adherencias: "Adherencias",
    votaciones: "Votaciones",
    menciones: "Menciones",
    comision: "Comisión",
    comisiones: "Comisiones",
    curricula: "Curricula",
    licencias: "Licencias",
    asistencias: "Asistencias",
    generatedProjects: "Proyectos Generados",
    inicialistas: "Inicialistas",
    adherentes: "Adherentes",
    datePresentation: "Fecha de presentación",
    dateResolution: "Fecha de resolución",
    media: "Medio",
    status: "Estatus",
    publicationTitle: "Título de la Publicación",
    publicationDrive: "Publicación (Drive)",
    date: "Fecha",
    dateInicial: "Fecha inicial",
    dateFinal: "Fecha final",
    webSource: "Fuente (web)",
    author_reporter: "Autor/Reportero",
    mentioned: "Contacto/Político mencionado",
    comments: "Comentarios",
    description: "Descripción",
    observations: "Observaciones",
    details: "Detalles",
    relations: "Relaciones",
    relationships: "Relaciones",
    rapporteur: "Ponente",
    documents: "Documentos",
    laws: "Leyes",
    legislationAndLaws: "Legislación y Leyes",
    inFavor: "A favor",
    against: "En contra",
    abstention: "Abstención",
    absent: "Ausente",
    votingText: "Texto de la Votación (PDF)",
    votingDrive: "Votación (Drive)",
    votingOficial: "Oficial de SCJN",
    votingFinal: "Sentencia final",
    projectDirection: "Sentido del proyecto",
    summary: "Sumario",
    isSubstitute: "¿Es suplente?",
    name: "Nombre",
    project: "Proyecto",
    result: "Resultado",
    privacyAndTerms: "Privacidad y condiciones",
    verifyPhone: "Verificar teléfono",
    state: "Estado",
    action: "Acción",
    true: "Si",
    false: "No",
    plenary: "PLENO",
    religiousInfo: "Información religiosa",
    additionalInfo: "Información complementaria",
    owner: "Propietario",
    substitute: "Suplente",
    sex: "Sexo",
    firstName: "Nombre(s)",
    lastName: "Apellido(s)",
    post: "Cargo",
    mainPost: "Cargo principal",
    birthdate: "Fecha de nacimiento",
    age: "Edad",
    kids: "Cantidad de hijos",
    quotas: "Por cuotas",
    hobby: "Hobby/pasatiempo",
    otherHobby: "Otro hobby",
    professed: "Religión profesada",
    otherProfessed: "Otra religión profesada",
    practiced: "Religión practicada",
    otherPracticed: "Otra religión practicada",
    parish: "Parroquia",
    diocese: "Diócesis",
    denomination: "Denominación religiosa",
    site: "Sitio",
    facebook: "Facebook",
    instagram: "Instagram",
    youtube: "Youtube",
    twitter: "Twitter",
    otherLink: "Otro link",
    extension: "Extensión",
    workEmail: "Correo de trabajo",
    otherEmail: "Correo personal",
    curriculum: "Curriculum (Link)",
    privateAddress: "Dirección particular",
    zipCode: "CP",
    country: "País",
    town: "Ciudad",
    colony: "Colonia",
    street: "Calle",
    externalNumber: "Num exterior",
    internalNumber: "Num interior",
    lot: "Lote",
    block: "Cuadra / Manzana",
    city: "Municipio / Alcadia",
    phone: "Teléfono",
    code: "Código",
    email: "E-mail",
    password: "Contraseña",
    theme: "Tema",
    locale: "Idioma",
    search: "Búsqueda",
    maritalStatus: "Estado civil",
    seeMore: "Ver más",
    seeLess: "Ver menos",
    requestChanges: "Solicitar ajustes",
    message: "Mensaje",
    total: "Total",
    lists: "Listados",
    evaluation: "Evaluación",
    votingEvaluation: "Evaluación general de los votos",
    evaluations: "Evaluaciones",
    evaluationsGeneral: "Evaluación general",
    evaluationsPerSubject: "Evaluaciones por temas",
    votingEvaluationsPerSubject: "Evaluaciones de los votos por temas",
    driveDocument: "Documento (Drive)",
    linkWeb: "Link (Web)",
    all: "Todos",
    unavailable: "Indisponible",
    active: "Activo",
    inactive: "Inactivo",
    headers: "Encabezados",
    legislation: "Legislación",
    comisionInitialist: "Comisión inicialista",
    dictamenIniciativa: "Dictamen de la iniciativa",
    sentenciaFinal: "Sentencia final",
    proyecto1: "Proyecto 1",
    proyecto2: "Proyecto 2",
    dictamenProject: "Dictamen del proyecto",
    categoria: "Categoría",
    actual: "Actual",
    percentagePeriod: "Porcentaje del periodo",
  },
  description: {
    privacyAndTerms:
      "Cuando usa nuestros servicios, nos confía su información.\n" +
      "Tal vez alguna información presente en esto sito no esté actualizada.\n" +
      "Requisito de edad: 14 años o más.",
    requestChanges: "Envíanos un mensaje solicitando ajustes. ¡Gracias!",
    searchGuide: "Intente hacer una búsqueda o filtrar registros.",
    chatAi: "Link del Chat IA exclusivo (en prueba)",
    noAuthorizationMessage:
      "Parece que aún no se ha concedido acceso a la aplicación. Por favor, habla con tu administrador para obtener acceso.",
    noDataAvailable: "No hay datos disponibles",
    pleaseFilterOrSearch: "Por favor, use los filtros o la barra de búsqueda para refinar los resultados.",
  },
  alert: {
    signIn: "Llena el siguiente formulario para acceder a la plataforma.",
    insertCode: "Por favor, insira abajo el código para verificar su teléfono.",
    receiveCode: "Para recibir un código se debe resolver el Captcha",
    selectState: "Por favor, elige un estado.",
  },
  text: {
    dateFormat: "DD/MM/AAAA",
  },
  select: {
    sex: {
      male: "Masculino",
      female: "Femenino",
    },
    theme: {
      light: "Claro",
      dark: "Oscuro",
    },
    state: "Estado",
  },
  button: {
    signIn: "Acceder con {provider}",
    signOut: "Salir",
    language: "Español",
    confirm: "Confirmar",
    update: "Actualizar",
    agree: "Aceptar",
    disagree: "Rechazar",
    cancel: "Cancelar",
    search: "Buscar",
    filter: "Filtrar",
    seeList: "Ver listado",
    seeFilters: "Ver filtros",
    seeEvaluations: "Ver evaluaciones",
    close: "Cerrar",
    chatAi: "Chat IA (en prueba)",
    printView: "Vista para impresión",
    typeReportTitle: "Escriba el título del informe",
    openFilters: "Abrir filtros",
  },
  hint: {
    account: "Cambia el campo y las opciones de 'comisión'.",
    projectType:
      "Cambia los campos y las opciones de 'posición', 'tipo' y 'leyes'.",
  },
  rule: {
    required: "Por favor, llene este campo.",
    invalid: "Valor inválido. Intente otro valor.",
    isNumber: "Utilize solo números.",
    isPhoneNumber: "Los números de teléfono deben ser como +5255XXXXXXXX",
    isDate: "Por favor, llene con una fecha válida.",
    isCode: "Código no es válido.",
    one: "Por favor, llene al menos un campo.",
    emailIsValid: "Por favor, llene con un e-mail válido",
    passwordHasValidCharacters:
      "La contraseña contiene caracteres no válidos: {chars}.",
    passwordHasValidLength:
      "La contraseña debe tener al menos {length} caracteres.",
    passwordHasLowerCase:
      "La contraseña debe tener al menos una letra minúscula.",
    passwordHasUpperCase:
      "La contraseña debe tener al menos una letra mayúscula.",
    passwordHasNumber: "La contraseña debe tener al menos un número.",
    passwordHasSpecialCharacter:
      "La contraseña debe tener al menos un carácter especial (@, $, !, %, *, #, ?, &, <, +, _).",
    credentialsAreNotWrong:
      "Las credenciales son incorrectas. Asegúrate de haber ingresado tu correo electrónico y contraseña correctamente.",
  },
  Masculino: "Masculino",
  Femenino: "Femenino",
  Feminino: "Femenino",
  Soltero: "Soltero",
  Casado: "Casado",
  Divorciado: "Divorciado",
  Viudo: "Viudo",
  "Unión libre": "Unión libre",
  Soltera: "Soltera",
  Casada: "Casada",
  Divorciada: "Divorciada",
  Viuda: "Viuda",
});
